import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import {
  GetTicketsListResponse,
  requestGetTickets,
} from "./getTickets.request";
import { GetTicketsParams } from "./getTickets.types";

const useGetTickets = (params: GetTicketsParams = {}) => {
  return useQuery<GetTicketsListResponse, ApiServiceError<ApiError>>({
    queryKey: [SUPPORT_TICKETS_QUERY_KEY, "list", params],
    queryFn: async () => await requestGetTickets(params),
    onError: toastServerError,
    keepPreviousData: true,
  });
};

export default useGetTickets;
